import { Subscription } from 'interfaces/system';
import { whatsAppProductIds } from './whatsAppProductIds';

type PlanType = 'LEGACY' | 'BASIC' | 'PRO';

export function loadPlanType(loadingSubscription: boolean, subscription: Subscription): PlanType {
	let planType: PlanType = 'LEGACY';

	// Assinatura sem itens (trial, resposta incompleta) conta como LEGACY em vez de quebrar a tela.
	const productId = subscription?.items?.[0]?.product_id ?? -1;

	if (!loadingSubscription) {
		planType = whatsAppProductIds.BASIC.includes(productId) ? 'BASIC' : planType;

		planType = whatsAppProductIds.PRO.includes(productId) ? 'PRO' : planType;
	}

	return planType;
}
